import {useEffect} from 'react';

type KeyHandlerMap = {
  [key: string]: (event: KeyboardEvent) => void;
};

export const useKeyboard = (handlers: KeyHandlerMap) => {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (handlers[e.code]) {
        handlers[e.code](e);
      }
    };

    window.addEventListener('keydown', handleKey);
    window.addEventListener('keyup', handleKey);

    return () => {
      window.removeEventListener('keydown', handleKey);
      window.removeEventListener('keyup', handleKey);
    };
  }, [handlers]);
};
